export default "__VITE_ASSET__52588aff__"